import { render, staticRenderFns } from "./EditorHeaderLogo.vue?vue&type=template&id=699135a4&scoped=true&"
import script from "./EditorHeaderLogo.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderLogo.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderLogo.vue?vue&type=style&index=0&id=699135a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699135a4",
  null
  
)

export default component.exports